import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "rating-graph"
}
const _hoisted_2 = { class: "rating-graph__percentage" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.summary)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("table", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.summary.items, (item) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: item.key
            }, [
              _createElementVNode("td", null, _toDisplayString(item.value), 1),
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("span", {
                    style: _normalizeStyle({ width: item.percent + '%' }),
                    class: "rating-graph__percentage-value"
                  }, null, 4)
                ])
              ]),
              _createElementVNode("td", null, _toDisplayString(item.count), 1)
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}